import { observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { GidSettingsStore } from "./GidSettingsStore";
import { GidSettingsRoutes } from "./GidSettingsRoutes";

type IProps = RouteComponentProps<{}> & {
    store: GidSettingsStore;
};

@observer
export class GidSettingsDeleteSigning extends React.Component<IProps, {}> {
    render() {
        let signInfo;
        if (this.props.store.deleteDeviceResponse) {
            signInfo = this.props.store.deleteDeviceResponse.signInfo;
        }

        return (
            <SigningComponent
                useWebVersion
                signingInfo={signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>
                                {ui.__("sidentitySettings.deleteDevice.confirm.title")}
                            </pr.SigningLabel>
                            <pr.SigningLabel>
                                {this.props.store.deviceToDelete && this.props.store.deviceToDelete.friendlyName}
                            </pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>

                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={async (response: ISigningResponse) => {
                    // Reload device list
                    await this.props.store.loadGidSettingsDevices();
                    // Goto success screen
                    pushRoute(GidSettingsRoutes.DELETE_DEVICE_SUCCESS);
                }}

                onRetry={async () => {
                    await this.props.store.deleteGidSettingsDevice();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsDeleteSigning.tsx